
import React, { useRef, useEffect } from 'react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { useIsMobile } from '@/hooks/use-mobile';

interface EmojiPickerProps {
  onEmojiSelect: (emoji: any) => void;
  onClose: () => void;
  isOpen: boolean;
}

const EmojiPicker = ({ onEmojiSelect, onClose, isOpen }: EmojiPickerProps) => {
  const isMobile = useIsMobile();
  const pickerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div 
      ref={pickerRef}
      className={`absolute z-50 ${
        isMobile 
          ? 'bottom-full left-0 right-0 mb-2' 
          : 'bottom-full right-0 mb-2'
      }`}
    >
      <div className="bg-gray-800 border border-gray-600 rounded-lg shadow-lg overflow-hidden">
        <Picker
          data={data}
          onEmojiSelect={onEmojiSelect}
          theme="dark"
          set="native"
          showPreview={false}
          showSkinTones={true}
          emojiSize={20}
          emojiButtonSize={28}
          maxFrequentRows={2}
          perLine={isMobile ? 8 : 9}
        />
      </div>
    </div>
  );
};

export default EmojiPicker;
